import { Center, CenterProps } from "@chakra-ui/react"
import React from "react"

import { Web3WalletContainer } from "../container/Web3WalletContainer"
import { ConnectWalletButton } from "./ConnectWalletButton"

interface ConnectWalletRequiredProps extends CenterProps {
    children: React.ReactNode
    buttonSize?: string
}

export function ConnectWalletRequired({ children, buttonSize, ...props }: ConnectWalletRequiredProps) {
    const { account } = Web3WalletContainer.useContainer()
    const isConnected = !!account

    if (isConnected) {
        return <>{children}</>
    }

    return (
        <Center overflow="hidden" w={"100%"} h={"100%"} {...props}>
            <ConnectWalletButton size={buttonSize} />
        </Center>
    )
}
